import { AnimationProps } from "framer-motion";

export const titleAnimation: AnimationProps = {
  initial: { scale: 0.6, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: {
    scale: 0.6,
    opacity: 0,
    transition: { delay: 0, duration: 0.1 },
  },
  transition: { delay: 0.2 },
};

export const iconAnimation: AnimationProps = {
  initial: { scale: 0.2, opacity: 0 },
  animate: { scale: 0.4, opacity: 1 },
  exit: {
    scale: 0.2,
    opacity: 0,
    transition: { delay: 0, duration: 0.1 },
  },
};
